import $ from "jquery";

const kruidenFilter = () => {
  const init = () => {
    kruiden();
  };
  const kruiden = () => {
    const el = {
      kruidens: ".over-kruiden__filter",
    };

    if ($(el.kruidens).length === 0) return;

    // Function to activate the "all" filter
    const activateAllFilter = () => {
      $(".filter-letter[data-letter='all']").addClass("active");
    };

    $(".filter-letter").on("click", function (e) {
      e.preventDefault();

      var letter = $(this).data("letter");
      var notFound = $(".over-kruiden__notfound");
      var kruidenItems = $(".kruiden");

      kruidenItems.hide();

      $(".filter-letter").removeClass("active");
      $(this).addClass("active");

      if (letter === "all") {
        kruidenItems.show();
        notFound.hide();
      } else {
        var filteredItems = $('.kruiden[data-letter="' + letter + '"]');

        if (filteredItems.length > 0) {
          filteredItems.show();
          notFound.hide();
        } else {
          notFound.show();
        }
      }
    });

    activateAllFilter();
  };

  init();
};
try {
  kruidenFilter();
} catch (error) {
  // eslint-disable-next-line no-console
  console.log(error);
}
